import { AccesoActions, AccesoActionTypes } from './acceso.actions';

export interface AccesoState {
	sidebarCollapsed: boolean,
	emailsFavsCollapsed: boolean,
	aplicacionesFavsCollapsed: boolean,
	basesConocimientoCollapsed: boolean,
	reportesCollapsed: boolean
}

const initialAccesoState: AccesoState = {
	sidebarCollapsed: true,
	emailsFavsCollapsed: false,
	aplicacionesFavsCollapsed: false,
	basesConocimientoCollapsed: false,
	reportesCollapsed: false
}

export function accesoReducer( state: AccesoState = initialAccesoState, action: AccesoActions ): AccesoState {
	switch( action.type ) {
		case AccesoActionTypes.SidebarToggleRequested:
			return { ...state, sidebarCollapsed: !state.sidebarCollapsed };
		case AccesoActionTypes.SidebarCollapseRequested:
			return { ...state, sidebarCollapsed: true };
		case AccesoActionTypes.AplicacionesFavsToggleRequested:
			return { ...state, aplicacionesFavsCollapsed: !state.aplicacionesFavsCollapsed };
		case AccesoActionTypes.EmailsFavsToggleRequested:
			return { ...state, emailsFavsCollapsed: !state.emailsFavsCollapsed };
		case AccesoActionTypes.BasesConocimientoToggleRequested:
			return { ...state, basesConocimientoCollapsed: !state.basesConocimientoCollapsed };
		case AccesoActionTypes.ReportesToggleRequested:
			return { ...state, reportesCollapsed: !state.reportesCollapsed };
		default:
			return state;
	}
}

